/**
 * Keep focused elements (and skip-link target) visible inside .page-wrapper,
 * which is the real scroll container at desktop widths.
 *
 * Important: never try to bring the *bottom* of a taller-than-viewport
 * element into view. `#MainContent` is tabindex="-1" and can receive click
 * focus when shoppers click non-link content inside it; scrolling for its
 * bottom jumps the page thousands of pixels down.
 */
(function () {
  'use strict';

  function scrollRoot() {
    return document.querySelector('.page-wrapper') || document.documentElement;
  }

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-group-height');
    var n = parseFloat(raw);
    return Number.isFinite(n) ? n : 72;
  }

  /**
   * @param {Element} el
   * @param {{ forceTop?: boolean }} [opts]
   */
  function scrollElementIntoView(el, opts) {
    if (!el || !(el instanceof Element)) return;
    var root = scrollRoot();
    var rootRect = root.getBoundingClientRect();
    var rect = el.getBoundingClientRect();
    var pad = headerOffset() + 8;
    var topGap = rect.top - rootRect.top;
    var bottomGap = rootRect.bottom - rect.bottom;
    var viewHeight = rootRect.height;
    var tallerThanView = rect.height > viewHeight - pad - 8;
    var forceTop = opts && opts.forceTop;

    // Skip targets / landmarks: only pin the top under the sticky header.
    if (forceTop || el.id === 'MainContent' || el.getAttribute('role') === 'main') {
      if (topGap < pad || topGap > viewHeight * 0.35) {
        root.scrollTop += topGap - pad;
      }
      return;
    }

    if (topGap < pad) {
      root.scrollTop += topGap - pad;
      return;
    }

    // Only nudge up for bottoms when the whole control can fit on screen.
    if (!tallerThanView && bottomGap < 8) {
      root.scrollTop += 8 - bottomGap;
    }
  }

  document.addEventListener(
    'focusin',
    function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.closest('[aria-hidden="true"], [hidden]')) return;
      // Ignore click/programmatic focus on the main landmark itself. Skip-link
      // handling below uses forceTop. Auto-scrolling main on every in-page
      // click is what jumped the blog library on empty-area clicks.
      if (target.id === 'MainContent' || target.getAttribute('role') === 'main') return;
      requestAnimationFrame(function () {
        scrollElementIntoView(target);
      });
    },
    true
  );

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.skip-to-content-link');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    event.preventDefault();
    if (typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (e) {
        target.focus();
      }
    }
    requestAnimationFrame(function () {
      scrollElementIntoView(target, { forceTop: true });
    });
  });
})();
